<template>
    <div>
        <rkm-row>
            <rkm-col cols="3">
                <rkm-form-select
                    :options="data.form.odontograma.odontogramas"
                    default-option-text="Atual"
                    label="Período"
                    show-default-option
                    text-field="data"
                    v-model="periodoId"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="auto">
                <rkm-form-radio-group
                    :disabled="somenteLeitura"
                    :validations="somenteLeitura ? {} : {required: true}"
                    label="Possui aparelho"
                    v-model="odontogramaEfetivo.possuiAparelho"
                >
                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                    <rkm-form-radio :value="false">Não</rkm-form-radio>
                </rkm-form-radio-group>
            </rkm-col>

            <rkm-col cols="auto">
                <rkm-form-radio-group
                    :disabled="somenteLeitura"
                    :validations="somenteLeitura ? {} : {required: true}"
                    label="Possui contenção"
                    v-model="odontogramaEfetivo.possuiContencao"
                >
                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                    <rkm-form-radio :value="false">Não</rkm-form-radio>
                </rkm-form-radio-group>
            </rkm-col>

            <rkm-col cols="auto">
                <rkm-form-checkbox-group
                    :disabled="somenteLeitura"
                    :options="proteseTotalOpcoes"
                    label="Prótese"
                    text-field="nome"
                    v-model="odontogramaEfetivo.protesesTotais"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>

        <rkm-tabs>
            <rkm-tab title="Dentes">
                <rkm-row>
                    <rkm-col cols="auto">
                        <rkm-form-radio-group
                            :disabled="somenteLeitura"
                            label="Mostrar dentes decíduos"
                            v-model="odontogramaEfetivo.mostrarDentesDeciduos"
                        >
                            <rkm-form-radio :value="true">Sim</rkm-form-radio>
                            <rkm-form-radio :value="false">Não</rkm-form-radio>
                        </rkm-form-radio-group>
                    </rkm-col>
                </rkm-row>

                <BoxDente :data="dataEfetiva" />
            </rkm-tab>

            <rkm-tab title="Arcadas">
                <BoxArcada :data="dataEfetiva" />
            </rkm-tab>
        </rkm-tabs>

        <BoxDenteSupranumerario :data="dataEfetiva" />
    </div>
</template>

<script>
// Components.
import BoxArcada from './components/arcada/Index'
import BoxDente from './components/dente/Index'
import BoxDenteSupranumerario from './components/dente-supranumerario/Index'

export default {
    components: {
        BoxArcada,
        BoxDente,
        BoxDenteSupranumerario,
    },
    computed: {
        proteseTotalOpcoes() {
            return [
                {id: 'superior', nome: 'Superior'},
                {id: 'inferior', nome: 'Inferior'},
            ]
        },
        odontogramaEfetivo() {
            if (this.periodoId) {
                return this.data.form.odontograma.odontogramas.find(odontograma => odontograma.id === this.periodoId)
            }

            return this.data.model.odontograma
        },
        somenteLeitura() {
            return !!this.data.readonly || !!this.periodoId
        },
        dataEfetiva() {
            return {
                form: this.data.form,
                model: {
                    ...this.data.model,
                    odontograma: this.odontogramaEfetivo,
                },
                readonly: this.somenteLeitura,
            }
        },
    },
    data: () => ({
        periodoId: null,
    }),
    props: {
        data: {type: Object, required: true},
    },
}
</script>
